import type {
  KlantTransactie,
  Transaction,
  CreateTransactieRequest,
  UpdateTransactieRequest,
} from '../types/api'
import { api } from '../utils/api'

export const getTransactions = async (customerNumber: number) => {
  const response = await api.get<KlantTransactie[]>(
    `/Transacties/${customerNumber}`
  )
  return response.data
}

export const putTransaction = async (
  transactionId: string | number,
  customerNumber: number,
  data: UpdateTransactieRequest
) => {
  const response = await api.put<Transaction>(
    `/Transacties/${transactionId}/${customerNumber}`,
    data
  )
  return response.data
}

export const postTransaction = async (
  customerNumber: number,
  transaction: CreateTransactieRequest
) => {
  const response = await api.post<Transaction>(
    `/Transacties/${customerNumber}`,
    transaction
  )
  return response.data
}

export const deleteTransaction = async (transactionId: string) => {
  const response = await api.delete<Transaction>(
    `/Transacties/${transactionId}`
  )
  return response.data
}
